import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ThumbsUp, ThumbsDown } from "@phosphor-icons/react";

export default function Feedback() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/admin/feedback/list");
      setRows(data);
    })();
  }, []);

  const likes = rows.filter((r) => r.feedback_type === "like").length;
  const dislikes = rows.filter((r) => r.feedback_type === "dislike").length;

  return (
    <div className="space-y-6" data-testid="feedback-root">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Customer Voice</div>
        <h1 className="mt-1 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Feedback</h1>
        <p className="mt-1 text-sm text-slate-600">Reactions captured directly from verification scans.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        <div className="rounded-lg border border-emerald-200 bg-emerald-50/50 p-6 flex items-center justify-between">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700">Likes</div>
            <div className="text-4xl font-extrabold tracking-tight text-slate-900 mt-2">{likes}</div>
          </div>
          <ThumbsUp size={48} weight="duotone" className="text-emerald-600" />
        </div>
        <div className="rounded-lg border border-rose-200 bg-rose-50/50 p-6 flex items-center justify-between">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-rose-700">Dislikes</div>
            <div className="text-4xl font-extrabold tracking-tight text-slate-900 mt-2">{dislikes}</div>
          </div>
          <ThumbsDown size={48} weight="duotone" className="text-rose-600" />
        </div>
      </div>

      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-200">
          <h3 className="text-lg font-bold text-slate-900">Recent feedback</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
              <tr>
                <th className="text-left px-4 py-3">Code</th>
                <th className="text-left px-4 py-3">Mobile</th>
                <th className="text-left px-4 py-3">Reaction</th>
                <th className="text-left px-4 py-3">When</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-6 py-10 text-center text-slate-500">No feedback yet.</td>
                </tr>
              )}
              {rows.map((r, i) => (
                <tr key={i} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-2.5 font-mono text-[12px] text-slate-700">{r.unique_code}</td>
                  <td className="px-4 py-2.5 text-slate-700">{r.mobile_number}</td>
                  <td className="px-4 py-2.5">
                    {r.feedback_type === "like" ? (
                      <span className="inline-flex items-center gap-1 text-emerald-700 font-semibold">
                        <ThumbsUp size={14} weight="fill" /> Like
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-rose-700 font-semibold">
                        <ThumbsDown size={14} weight="fill" /> Dislike
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2.5 text-xs text-slate-500">{new Date(r.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
